import { Trademark } from '../../types/Trademark'

export const austria: Trademark[] = [
    {
        title: 'CrowdTransfer',
        iconUrl: 'https://reshape.sport1.de/c/t/ef997fe2-8e4b-4ca4-896c-4604443f002b/200x100',
        iconDarkUrl: 'https://reshape.sport1.de/c/t/05e302e6-7de6-40d5-aa8e-7f8d0ac454b0/200x100',
        targetUrl: 'https://crowdtransfer.io/',
    },
    {
        title: 'Gambit',
        iconUrl: 'https://reshape.sport1.de/c/t/4ef044e9-2a56-4c3a-be0f-f5c9439a6cc2/0x0',
        iconDarkUrl: 'https://reshape.sport1.de/c/t/4ef044e9-2a56-4c3a-be0f-f5c9439a6cc2/0x0',
        targetUrl: 'https://company.gambit.ai/',
    },
    {
        title: 'Muuvr',
        iconUrl: 'https://reshape.sport1.de/c/t/42bdd34c-9d52-412e-84af-9f60025a4999/200x100',
        iconDarkUrl: 'https://reshape.sport1.de/c/t/09fd48d7-df10-4538-8dbc-db32b162578a/200x100',
        targetUrl: 'https://muuvr.io/',
    },
    {
        title: 'Jackpot 50',
        iconUrl: 'https://reshape.sport1.de/c/t/7411d924-6892-4677-8fd1-42967e153d99/200x100',
        iconDarkUrl: 'https://reshape.sport1.de/c/t/797d29bd-d1c2-4c42-b176-498dc3039294/200x100',
        targetUrl: 'https://www.jackpot50.de/de',
    },
    {
        title: 'Clanq',
        iconUrl: 'https://reshape.sport1.de/c/t/c58e891a-8df1-4cd6-a539-5beebf136aa7/200x100',
        iconDarkUrl: 'https://reshape.sport1.de/c/t/2037cfbe-9e7e-459d-9ca2-0c60815e61ed/200x100',
        targetUrl: 'https://www.clanq.de/',
    },
    {
        title: 'Cheeer',
        iconUrl: 'https://reshape.sport1.de/c/t/1bc8d8f5-7e56-4df3-b949-88baaf29e42d/200x100',
        iconDarkUrl: 'https://reshape.sport1.de/c/t/a2870b41-4292-426b-bad6-c6e26ffb56c3/200x100',
        targetUrl: 'https://www.cheeer.com/',
    },
    {
        title: 'TigerSpin',
        iconUrl: 'https://reshape.sport1.de/c/t/75317933-68e2-4c73-95ca-666beb1da880/200x100',
        iconDarkUrl: 'https://reshape.sport1.de/c/t/0590fd3f-32c7-4c92-81ba-f617b89056fa/200x100',
        targetUrl: 'https://www.tigerspin.de/',
    },
]
